import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, FormInput, Button } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import { Flex } from 'rebass/styled-components';
import * as Yup from 'yup';

export const ModalCreateApiKey = ({ onClose, onSubmit, isLoading = false, initialValues = { label: '' } }) => {
  const formRef = useRef();
  const validationSchema = Yup.object().shape({
    label: Yup.string().required('A key name is required').trim().max(255, 'Key name must be less than 255 characters'),
  });

  return (
    <Modal
      title="Create a new API key"
      isOpen
      onCancel={onClose}
      actions={
        <Flex justifyContent="flex-end" sx={{ gap: '16px' }}>
          <Button onClick={() => formRef.current?.handleSubmit()} loading={isLoading || formRef.current?.isSubmitting}>
            Create API key
          </Button>
        </Flex>
      }
    >
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <Form>
          <Field
            id="apiKeyLabel"
            name="label"
            component={FormInput}
            label="Key name"
            helpText="Give your key a name so you can recognize it later."
            placeholder="e.g., Zapier integration"
            size="medium"
          />
        </Form>
      </Formik>
    </Modal>
  );
};

ModalCreateApiKey.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  initialValues: PropTypes.shape({
    label: PropTypes.string,
  }),
};

ModalCreateApiKey.defaultProps = {
  isLoading: false,
  initialValues: { label: '' },
};
